export const HEADER_TAGNAME = 'header'
export const BACK_BUTTON_SIZE = 16

export enum HeaderTestIds {
	CloseSearchBar = 'header.searchBar.close',
	OpenSearchBar = 'header.userMenu.search.button',
	SearchInput = 'header.searchBar.input',
	SearchBar = 'header.searchBar',
	SearchBarSubMenu = 'header.searchBar.subMenu',
}

export enum TestIds {
	SearchBox = 'searchBox',
	SearchBoxForm = 'searchBox.form',
	SearchBoxInput = 'searchBox.input',
	SearchBoxSubmit = 'searchBox.submit',
	SearchBoxIcon = 'searchBox.icon',
}

export enum AllowedIcons {
	Scan = 'scan',
}
